import type { HTMLAttributes } from "react";
import { getLoadingSkeleton, type LoadingSkeletonSurface } from "@/core/ui/loading-skeletons";
import { cn } from "@/lib/utils";

export function SkeletonBlock({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("animate-pulse rounded-md bg-muted", className)} {...props} />;
}

export function QuerySkeleton({
  surface,
  className,
}: {
  surface: LoadingSkeletonSurface;
  className?: string;
}) {
  const config = getLoadingSkeleton(surface);
  return (
    <div className={cn("space-y-4 rounded-lg border border-border bg-card p-4", className)} aria-busy="true">
      <div className="sr-only">{config.label}</div>
      <SkeletonBlock className="h-5 w-48" />
      <div
        className="grid gap-3"
        style={{
          gridTemplateColumns: `repeat(${config.columns}, minmax(0, 1fr))`,
        }}
      >
        {Array.from({ length: config.rows * config.columns }, (_, index) => (
          <SkeletonBlock key={index} className="h-10" />
        ))}
      </div>
    </div>
  );
}
